/**
 * AJAX pagination for collection "Show more" (CTA) mode.
 * Fetches the same section as facets.js (?section_id=…) so URLs stay in sync with filters/sort.
 */
(function () {
  const productGridContainer = document.getElementById('ProductGridContainer');
  if (!productGridContainer?.querySelector('.pagination-wrapper--cta')) return;

  const cancelScrollTriggers = (root) => {
    root.querySelectorAll('.scroll-trigger').forEach((el) => {
      el.classList.add('scroll-trigger--cancel');
    });
  };

  productGridContainer.addEventListener('click', (event) => {
    const showMore = event.target.closest('.pagination-wrapper--cta a.pagination__item--cta');
    const showPrev = event.target.closest('.pagination-wrapper--cta a.pagination__item--cta-nav');
    if (!showMore && !showPrev) return;

    event.preventDefault();
    event.stopPropagation();

    const link = showMore || showPrev;
    const href = link.getAttribute('href');
    if (!href) return;

    loadCollectionPage(href, Boolean(showMore));
  });

  async function loadCollectionPage(href, append) {
    const collectionEl = productGridContainer.querySelector('.collection');
    const liveGrid = productGridContainer.querySelector('#product-grid');
    const sectionId = liveGrid?.dataset?.id;

    if (!collectionEl || !liveGrid || !sectionId) {
      window.location.href = href;
      return;
    }

    if (collectionEl.classList.contains('loading')) return;

    const url = new URL(href, window.location.href);
    url.searchParams.set('section_id', sectionId);

    collectionEl.classList.add('loading');

    try {
      const response = await fetch(url.toString());
      if (!response.ok) throw new Error(String(response.status));
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fetchedContainer = doc.getElementById('ProductGridContainer');
      if (!fetchedContainer) throw new Error('Missing ProductGridContainer');

      const fetchedGrid = fetchedContainer.querySelector('#product-grid');
      const fetchedPagination = fetchedContainer.querySelector('.pagination-wrapper');

      if (!fetchedGrid) throw new Error('Missing product grid');

      if (append) {
        fetchedGrid.querySelectorAll(':scope > li').forEach((li) => {
          const node = document.importNode(li, true);
          cancelScrollTriggers(node);
          liveGrid.appendChild(node);
        });
      } else {
        liveGrid.innerHTML = fetchedGrid.innerHTML;
        cancelScrollTriggers(liveGrid);
      }

      const livePagination = productGridContainer.querySelector('.pagination-wrapper');
      if (fetchedPagination) {
        const imported = document.importNode(fetchedPagination, true);
        if (livePagination) {
          livePagination.replaceWith(imported);
        } else {
          collectionEl.appendChild(imported);
        }
      } else if (livePagination) {
        livePagination.remove();
      }
    } catch {
      window.location.href = href;
    } finally {
      collectionEl.classList.remove('loading');
    }
  }
})();
